<template>
  <el-form ref="form" :model="formData" size="small">
    <el-row>
      <el-form-item
        :label="$l('INDEX.form_label_ecom_evg_platform') || '电商平台'"
      >
        <dict-select
          v-model="formData.platformCode"
          :placeholder="
            $l('INDEX.form_placeholder_ecom_evg_platform') || '请选择电商平台'
          "
          url="/ecom/evg/platform/select"
          :selectedLabel.sync="formData.platformName"
          filterable
          clearable
        ></dict-select>
      </el-form-item>
    </el-row>
    <el-row>
      <el-upload
        drag
        action="#"
        :file-list="listFile"
        :auto-upload="false"
        :on-change="onFileChange"
        :on-remove="() => (listFile = [])"
        accept=".csv,.xlsx,.txt"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">
          {{ $l('INDEX.file_upload_tips_first') || '将文件拖到此处，或' }}
          <em>{{ $l('INDEX.file_upload_tips_last') || '点击上传' }}</em>
        </div>
      </el-upload>
    </el-row>
  </el-form>
</template>

<script>
import EditLoading from '@/mixins/edit-loading'
const fileTypes = ['ORDER', 'INV', 'SKU', 'FIN', 'AD', 'WMPOSSALES', 'WMWEEKPO']
export default {
  mixins: [EditLoading],
  props: { fileType: { type: String, default: '' } },
  data() {
    return {
      formData: { platformCode: '', platformName: '' },
      listFile: [],
    }
  },
  methods: {
    onFileChange(file) {
      this.listFile = [file]
    },
    async upload() {
      if (!this.fileType) {
        throw new Error(
          'file-type value is null, value: ORDER/INV/SKU/FIN/AD .'
        )
      }
      if (!fileTypes.includes(this.fileType)) {
        throw new Error(
          'file-type no value exists, value: ORDER/INV/SKU/FIN/AD .'
        )
      }

      if (!this.listFile || !this.listFile.length) {
        this.$message({
          message: this.$l('INDEX.tips_upload_file') || '请选择需要上传的文件',
          type: 'warning',
        })
        return false
      }
      const { raw, name: originalFileName } = this.listFile[0]
      this.loadingOpen()
      const uploadRes = await this.$api.SYS_UPLOAD(raw).catch(() => null)
      const { status: uploadStatus, body } = uploadRes || {}
      if (200 !== uploadStatus) {
        this.$message.error(
          this.$l('INDEX.uploader_label_status_error') || '上传失败'
        )
        this.loadingClose()
        return
      }
      const { fileId: fileMd5, url: fileUrl } = body
      const params = {
        fileMd5,
        fileUrl,
        originalFileName,
        ...this.formData,
        fileType: this.fileType,
      }

      const res = await this.$api.ecomImpWmSalesPoUploadApi(params).catch(() => null)
      const { status } = res || {}
      this.loadingClose()
      if (200 !== status) {
        this.$message.error(
          this.$l('INDEX.uploader_label_status_error') || '上传失败'
        )
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.uploader_label_status_success') || '上传成功',
        type: 'success',
      })
      this.$emit('close')
      this.$emit('reload')
    },
  },
}
</script>
